class MATAProductTopCarousel {
  constructor( i, e ) {
    this.$index = i;
    this.$element = $( e );

    this.selectors = {
      item: ".product-top__media",
      thumbnails: ".product-top__media-thumbnails",
    };

    this.init();
  }

  init() {
    this.$thumbnails = this.$element.find( `+ ${this.selectors.thumbnails}` );

    this.initCarousel();
  }

  initCarousel() {
    this.$element.flickity({
      wrapAround: false,
      prevNextButtons: false,
      adaptiveHeight: false,
      pageDots: true,
      cellAlign: "left",
      groupCells: false,
      contain: true,
      on: {
        ready: () => {
          this.$thumbnails.flickity({
            asNavFor: this.$element.get(0),
            wrapAround: false,
            prevNextButtons: false,
            adaptiveHeight: false,
            pageDots: false,
            cellAlign: "center",
            groupCells: false,
            contain: true,
            freeScroll: true
          });
        }
      }
    });
  }

  destroyCarousel() {
    if (this.$element.data('flickity')) {
      this.$element.flickity('destroy');
    }
    if (this.$thumbnails && this.$thumbnails.data('flickity')) {
      this.$thumbnails.flickity('destroy');
    }
  }
}